export default __webpack_public_path__ + "static/media/CEM-Maths.2e4a061f.webp";